import { jsx as _jsx } from "react/jsx-runtime";
import { useEventReporter, useOverlayContext, useStoreActions } from '~/contexts';
import CopyAPIKeyModal from './CopyAPIKeyModal';
const INTEGRATION_CONFIGS = {
    make: {
        slug: 'make',
        title: 'Make',
        integrationUrl: 'https://www.make.com/en/apps'
    },
    monday: {
        slug: 'monday',
        title: 'monday.com',
        integrationUrl: 'https://monday.com/'
    },
    levvy: {
        slug: 'levvy',
        title: 'Levvy',
        integrationUrl: 'https://www.levvy.com/'
    },
    count: {
        slug: 'count',
        title: 'COUNT',
        integrationUrl: 'https://getcount.com/'
    },
    zapier: {
        slug: 'zapier',
        title: 'Zapier',
        integrationUrl: 'https://zapier.com/app/connections'
    },
    ping: {
        slug: 'ping',
        title: 'Ping',
        integrationUrl: 'https://www.pingassistant.com/'
    },
    abacor: {
        slug: 'abacor',
        title: 'Abacor',
        integrationUrl: 'https://www.abacor.com/'
    }
};
export function useCopyAPIKeyIntegration(slug) {
    const { logBI } = useStoreActions();
    const { reportToAppcues, reportToGtm, reportToHeap, reportToHubspot } = useEventReporter();
    const overlayContext = useOverlayContext();
    const config = INTEGRATION_CONFIGS[slug];
    const reportConnect = ()=>{
        logBI(12050);
        reportToAppcues('button-click', "".concat(slug, "-vendor-clicked-connect"));
        reportToGtm('button-click', "".concat(slug, "-vendor-clicked-connect"));
        reportToHeap('integrations', 'click', "".concat(slug, "-connect"));
        reportToHubspot("vendor_clicked_connect_to_".concat(slug));
    };
    const showCopyAPIKeyModal = ()=>{
        reportConnect();
        overlayContext.showModal({
            biName: 'copy_api_key_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(CopyAPIKeyModal, {
                    dismissModal: dismissModal,
                    slug: slug,
                    title: config.title,
                    integrationUrl: config.integrationUrl
                });
            }
        });
    };
    return {
        showCopyAPIKeyModal
    };
}
